import lockIcon from "../../assets/icons/lock.svg";
import visibilityOffIcon from "../../assets/icons/visibility_off.svg";

export const ERROR_RENDERS = {
  UNAUTHORIZED_APPLICATION: {
    errorImage: null,
    errorText:
      "You are not authorized to view this application. Request permission in MyElectronicAccess. Once approved Log In Again.",
    errorTextStyling: { color: "#B50015", fontSize: "14px" },
  },
  UNAUTHORIZED_PAGE: {
    errorImage: lockIcon,
    errorText:
      "You are not authorized to view this page. If you think you reached this page in error you may not have the correct permissions in MyElectronicAccess.",
    errorTextStyling: { color: "#B50015", fontSize: "14px" },
  },
  PAGE_NOT_FOUND: {
    errorImage: visibilityOffIcon,
    errorText: "This Page Was Not Found or Unavailable",
    errorTextStyling: null,
  },
};
